var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGebruikersnaamIcoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#BEBEBE",
    width: 34.461,
    height: 32,
    viewBox: "0 0 34.461 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Gebruikersnaam_Icoon",
    "data-name": "Gebruikersnaam Icoon",
    d: "M24.191,28.038v-2.03c2.711-1.528,4.923-5.337,4.923-9.147,0-6.118,0-11.077-7.385-11.077s-7.385,4.959-7.385,11.077c0,3.81,2.212,7.619,4.923,9.147v2.03C10.918,28.721,4.5,32.824,4.5,37.784H38.96C38.96,32.824,32.541,28.721,24.191,28.038Z",
    transform: "translate(-4.499 -5.784)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGebruikersnaamIcoon);
export default __webpack_public_path__ + "static/media/Gebruikersnaam-Icoon.a61ef187.svg";
export { ForwardRef as ReactComponent };